import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import Icon from '~/components/Icon/Icon';
import InfoCircleIcon from '~/components/MarketplaceIcons/InfoCircleIcon';

import { PRODUCT_NOTICES } from './constants';
import ProductInfoModal from './ProductInfoModal';

/**
 * DubaiExpress product-page notice badges ("Гарантия и возврат", "Товар
 * из-за границы"). Each pill opens an info modal with the corresponding terms.
 */
const ProductInfoBadges = ({
  className,
  variant = 'pill',
}: {
  className?: string;
  /** `pill` is the brand-tinted chip; `text` the plain brand-colored link of the DubaiExpress product page. */
  variant?: 'pill' | 'text';
}) => {
  const [openId, setOpenId] = useState<string | null>(null);
  const activeNotice = PRODUCT_NOTICES.find((notice) => notice.id === openId);
  const isPill = variant === 'pill';

  return (
    <div
      className={classes([
        'flex flex-wrap items-center',
        isPill ? 'gap-1' : 'gap-2',
        className,
      ])}
    >
      {PRODUCT_NOTICES.map((notice) => (
        <button
          key={notice.id}
          type="button"
          onClick={() => setOpenId(notice.id)}
          className={
            isPill
              ? 'flex h-5 cursor-pointer items-center gap-0.5 rounded-full border-0 bg-graphic-transparent-brand-10 py-0.5 pr-3 pl-0.5 font-customer-text text-[12px] text-graphic-regular-brand leading-[14px] tracking-tight'
              : 'flex cursor-pointer items-center gap-1.5 whitespace-nowrap border-0 bg-transparent p-0 font-medium text-[#E94E1A] text-[14px] leading-5 transition-colors duration-[120ms] [font-family:inherit] hover:text-[#C43F12]'
          }
        >
          {isPill ? (
            <Icon type="info" size={16} className="shrink-0" />
          ) : (
            <InfoCircleIcon className="size-3.5 shrink-0" />
          )}
          {notice.label}
        </button>
      ))}
      <ProductInfoModal
        isOpen={Boolean(activeNotice)}
        onClose={() => setOpenId(null)}
        title={activeNotice?.modalTitle ?? ''}
      >
        {activeNotice?.content}
      </ProductInfoModal>
    </div>
  );
};

export default observer(ProductInfoBadges);
